<template>
    <div class="card-container">
        <h2 class="mt-10 mb-0" v-if="cardSources.length"> Debit/Credit Card </h2>
        <div v-for="source in cardSources" :key="source.payment_source.id" class="card-item">
            <input type="radio"
                class="input__radio-item"
                :id="source.payment_source.id"
                :value="source.payment_source.id"
                v-model="selectedPaymentMethod" />

            <label :for="source.payment_source.id" class="input__radio-label">
                **** **** **** {{source.payment_source.card.last4}}
                <img class="payment-icon" v-if="source.payment_source.card.brand === 'visa'" src="@/assets/images/icons/visa-icon.svg" />
                <img class="payment-icon" v-else-if="source.payment_source.card.brand === 'mastercard'" src="@/assets/images/icons/mastercard-icon.svg" />

                {{source.payment_source.card.expiry_month}}/{{source.payment_source.card.expiry_year}}
            </label>
        </div>

        <h2 class="mt-5" v-if="paypalSources.length"> Paypal </h2>
        <div v-for="source in paypalSources" :key="source.payment_source.id" class="card-item">
            <input type="radio"
                class="input__radio-item"
                :id="source.payment_source.id"
                :value="source.payment_source.id"
                v-model="selectedPaymentMethod" />

            <label :for="source.payment_source.id" class="input__radio-label">
                {{source.payment_source.paypal.email}}
                <img class="payment-icon paypal-icon" src="@/assets/images/icons/paypal-icon.png" />
            </label>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Payment',
    data() {
        return {
            selectedPaymentMethod: null,
        };
    },
    computed: {
        ...mapGetters({
            paypalSources: 'payment/getPaypalPaymentSources',
            cardSources: 'payment/getCardPaymentSources',
            allSources: 'payment/getPaymentSources',
        }),
    },
    mounted() {
        this.selectedPaymentMethod = this.allSources.length ? this.allSources[0].payment_source.id : null;
    },
    watch: {
        selectedPaymentMethod(newMethod) {
            this.$store.commit('payment/setSelectedPaymentSource', newMethod);
        },
        allSources() {
            this.selectedPaymentMethod = this.allSources.length ? this.allSources[0].payment_source.id : null;
        },
    },
};
</script>

<style scoped>
.card-container {
    display: grid;
    margin-bottom: 10px;
}

.card-item {
    margin: 0 auto;
    display: inline-block;
}

.payment-icon {
    height: 40px;
    width: 70px;
    margin: 0px 5px 4px;
    display: inline-block;
}

.paypal-icon {
    height: unset;
}
</style>
